import React from "react";
import BrowserBezel from "components/BrowserBezel";
import CheckoutPreviewLoader from "components/CheckoutPreview/Loader";
import Padder from "components/Padder";
import { getShimmerClass } from "utils/constants/ui";
import { APP_CONTENT_MAX_WIDTH } from "utils/constants/ui";

const PickerLoader = ({ shimmerClass }) => (
  <div className="pa3 w-100 ba hairline-1">
    <div className="w-100 flex flex-row justify-between pb2">
      <div style={{ height: 24 }} className={`${shimmerClass} w-30`} />
      <div style={{ height: 24 }} className={`${shimmerClass} w-10`} />
    </div>
    <div className="w-100 flex flex-row justify-between">
      <div style={{ height: 16 }} className={`${shimmerClass} w-10`} />
      <div style={{ height: 16 }} className={`${shimmerClass} w-10`} />
    </div>
  </div>
);

const SectionLoader = ({ shimmerClass }) => (
  <div className="ba b--black-10 br2 w-100">
    <div className="pa3 w-100 flex flex-row bb b--black-10 justify-between items-center">
      <div className="fw6 f4 h2 shimmer w-20"></div>
    </div>
    <div className="list pa0 ma0 w-100 pa3">
      {new Array(2).fill("").map((_, nodeIx) => (
        <div key={nodeIx} className={nodeIx ? "pt3" : ""}>
          <PickerLoader key={nodeIx} shimmerClass={shimmerClass} />
        </div>
      ))}
    </div>
  </div>
);

const BuilderLinkLoader = ({ withShimmer }) => {
  const shimmerClass = getShimmerClass(withShimmer);
  return (
    <div className={APP_CONTENT_MAX_WIDTH}>
      <div className="w-100 pt4">
        <div className="flex flex-column flex-row-l">
          <div className="w-100 w-50-l pa3 h-100">
            {new Array(2).fill("").map((_, nodeIx) => (
              <div key={nodeIx} className={nodeIx ? "pt3" : ""}>
                <SectionLoader shimmerClass={shimmerClass} />
              </div>
            ))}
          </div>
          <div className="w-100 w-50-l pa3">
            <BrowserBezel>
              <div className="pa3">
                <CheckoutPreviewLoader withShimmer />
              </div>
            </BrowserBezel>
          </div>
        </div>
      </div>
      <Padder />
    </div>
  );
};

export default BuilderLinkLoader;
